module.exports = __webpack_public_path__ + "img/company_thirteen.b7e2962f.svg";